import { useEffect, useState, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function MediaPickerDialog({ open, onOpenChange, onSelect }) {
  const [items, setItems] = useState([]);
  const fileRef = useRef();

  const load = () => api.get("/media", { params: { limit: 100 } }).then(({ data }) => setItems(data.items));

  useEffect(() => {
    if (open) load();
  }, [open]);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post("/media/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
    onSelect(`${BACKEND_URL}${data.url}`, data);
    onOpenChange(false);
    e.target.value = "";
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="media-picker-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between pr-8">
            Изберете изображение
            <Button size="sm" variant="outline" onClick={() => fileRef.current.click()} data-testid="media-picker-upload-btn">
              <Upload className="w-4 h-4 mr-2" /> Качи ново
            </Button>
          </DialogTitle>
        </DialogHeader>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={upload} />
        <div className="grid grid-cols-4 gap-3 max-h-[420px] overflow-y-auto">
          {items.map((m) => (
            <button
              key={m.id}
              onClick={() => { onSelect(`${BACKEND_URL}${m.url}`, m); onOpenChange(false); }}
              className="aspect-square overflow-hidden border-2 border-transparent hover:border-[#A6192E]"
              data-testid={`media-picker-item-${m.id}`}
            >
              <img src={`${BACKEND_URL}${m.url}`} alt={m.alt_text} className="w-full h-full object-cover" />
            </button>
          ))}
          {items.length === 0 && <p className="col-span-4 text-sm text-[#718096]">Няма качени изображения. Качете първото си изображение.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
